<template>
  <q-btn
    @click="buttonClick"
    :label="buttonText"
    :no-caps="!capslock"
    :color="buttonColor"
    text-color="white"
    :loading="buttonLoading"
    :disable="buttonDisable"
  />
</template>

<script>
export default {
  name: "ButtonGeneral",

  props: {
    buttonColor: {
      type: String,
      default: "primary",
    },
    capslock: {
      type: Boolean,
      default: true,
    },
    buttonText: String,
    buttonClick: {
      type: Function,
      required: true,
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
    buttonDisable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
